import { ENV } from '../../../shared/config/env';
import { createApiClient } from '../../../shared/services/api';
import type { ApiResult } from '../../../shared/types/api';
import type { EnqueteResponse } from '../types';

const API_BASE_URL = ENV.API_BASE_URL;
const USE_MOCK = !API_BASE_URL;

export const surveyRepository = {
  getEnqueteUrl: async (
    inquiryId: string,
    token?: string
  ): Promise<ApiResult<EnqueteResponse>> => {
    if (USE_MOCK) {
      return {
        success: true,
        data: { enqueteUrl: `https://dev-enq.homekarte.com/123456?uid=${inquiryId}` },
      };
    }

    const headers: Record<string, string> = {};
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const client = createApiClient({ baseUrl: API_BASE_URL, headers });
    return client.get<EnqueteResponse>(
      `/api/v1/inquiries/enquete?inquiryId=${inquiryId}`
    );
  },
};
